import React from 'react';
import { observer } from 'mobx-react';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';
import URLParameterRegistrationFormVM from './url-parameter-registration-form.viewmodel';
import { URL_PARAMETER_REGISTRATION_STATUS_TEXT } from './url-parameter-registration.text';

interface IURLParameterRegistrationFormPresentationProps {
    vm: URLParameterRegistrationFormVM;
}

const URLParameterRegistrationFormPresentation = observer((props: IURLParameterRegistrationFormPresentationProps): JSX.Element => {
    const { vm } = props;
    const { settingsEntity } = vm;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form'>
                    <div className='oe-form__body'>
                        <div className='m-top-10px m-bottom-0px flex center'>
                            <OEToggle
                                isSelected={settingsEntity.enabled}
                                onClick={settingsEntity.toggleEnabled}
                                dataTestId='url-parameter-registration'
                            />
                            <Text
                                {...URL_PARAMETER_REGISTRATION_STATUS_TEXT}
                                values={{
                                    suffix: settingsEntity.suffix
                                }}
                                className='line-height-25px'
                            />
                        </div>
                    </div>
                </div>
            }
            footer={
                <AccountAdminSettingFormFooter
                    handleClose={vm.handleClose}
                    handleSubmit={vm.handleSubmit}
                    isDisabled={vm.saving}
                />
            }
        />
    );
});

export default URLParameterRegistrationFormPresentation;
